import { Select, Space } from "antd";
import React, { useEffect, useState } from "react";

import { getTeamTimezones } from "../../lib/queries";

const { Option } = Select;

type Timezone = {
  name: string; // timezone name
};

type Props = {
  onChange: React.Dispatch<React.SetStateAction<any>>;
  teamId: string; // the team id
  selected?: string; // the currently selected timezone value
};

/**
 * A dropdown that shows the timezones for a given team
 * @param props @see Props
 * @returns TSX component
 */
function TimezoneFilter(props: Props) {
  const [selectedTimezone, setSelectedTimezone] = useState<string>(
    props.selected ? props.selected : ""
  );
  const [timezones, setTimezones] = useState<Timezone[]>([]);
  const [timezoneTags, setTimezoneTags] = useState<Timezone[]>([]);
  const [timezoneTagsIds, setTimezoneTagsIds] = useState<string[]>([]);

  /**
   * Loads the timezones for a given team
   */
  const loadTeamTimezones = async () => {
    const data = await getTeamTimezones(props.teamId);
    setTimezones(data);
  };

  useEffect(() => {
    loadTeamTimezones();
  }, []);

  // This will try to find the selected timezone tag in the set of of all timezones
  function returnTimezoneObj(value: string) {
    const filteredTimezones = timezones.find(
      (item: Timezone) => item.name === value
    );
    if (filteredTimezones) return filteredTimezones;
    return [];
  }

  /**
   * This will update the selected timezone tag anytime the user deselects one
   * in he timezone tags selection modal
   * @param selection - the selected timezone
   */
  const onSelect = async (selection: string) => {
    const selectedTimezoneTag = returnTimezoneObj(selection);
    const newTimezoneTags = timezoneTags.concat(selectedTimezoneTag);
    const newTimezoneTagsIds = newTimezoneTags.map((item) => item.name);
    setTimezoneTags(newTimezoneTags);
    setTimezoneTagsIds(newTimezoneTagsIds);

    props.onChange({
      filter_type: "timezone",
      filter_settings: { timezone: newTimezoneTagsIds },
    });
  };

  /**
   * This will update the selected timezone tags anytime the user deselects one
   * in the timezone tags selection modal
   * @param selection - the selected timezone
   */
  const onDeselect = async (selection: string) => {
    const remainingTimezoneTags = timezoneTags.filter(
      (item: Timezone) => item.name !== selection
    );
    const remainingTimezoneTagsIds = remainingTimezoneTags.map(
      (item: Timezone) => item.name
    );
    setTimezoneTags(remainingTimezoneTags);
    setTimezoneTagsIds(
      remainingTimezoneTags.map((item: Timezone) => item.name)
    );
    if (remainingTimezoneTagsIds.length === 0) {
      props.onChange({ filter_type: "timezone" });
    } else {
      props.onChange({
        filter_type: "timezone",
        filter_settings: { timezone: remainingTimezoneTagsIds },
      });
    }
  };

  // @ts-ignore
  // @ts-ignore
  // @ts-ignore
  return (
    <>
      <Space>
        <span>Select timezone: </span>
        <Select
          mode="multiple"
          showSearch
          showArrow
          // @ts-ignore
          value={timezoneTagsIds}
          style={{ width: "500px", borderRadius: 10 }}
          onSelect={onSelect}
          onDeselect={onDeselect}
          optionFilterProp="name"
        >
          {timezones.map((item: Timezone) => {
            return (
              <Option key={item.name} value={item.name} name={item.name}>
                {item.name}
              </Option>
            );
          })}
        </Select>
      </Space>
    </>
  );
}

export default TimezoneFilter;
